// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__alZBw","content":"styles_content__3SN-3"};